import React from 'react';
import ReactModal from 'react-modal';

export default function Modal(props) {
  const innerWidthClass = props.innerWidth || 'w-11/12 sm:w-3/4 md:max-w-xl';

  return (
    <div className="flex w-full justify-center items-center">
      <ReactModal
        {...props}
        style={{
          content: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflowX: 'hidden',
            overflowY: 'auto',
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 50,
            border: 'none',
            backgroundColor: 'transparent',
            padding: 0,
          },
          overlay: {
            flexDirection: 'column',
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 50,
          },
        }}
        ariaHideApp={false}
      >
        <div className={`flex flex-col mx-auto ${innerWidthClass}`}>
          {/* 헤더: relative 설정 */}
          <div
            className="flex flex-row w-full h-12 bg-cust-dark-gray items-center justify-center px-4 rounded-t"
            style={{ position: 'relative' }}
          >
            <span className="text-white font-bold text-base md:text-lg truncate">
              {props.title}
            </span>

            {/* 닫기 버튼: 인라인 스타일로 우측 끝 정렬 확실하게 보장 */}
            {props.hasCloseBtn && (
              <button
                type="button"
                onClick={props.onRequestClose}
                className="text-white hover:text-gray-300 focus:outline-none"
                style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '4px',
                }}
                aria-label="닫기"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            )}
          </div>

          {/* 모달 컨텐츠 */}
          <div className="flex flex-col flex-1 min-h-0 w-full bg-white rounded-b overflow-hidden">
            {props.children}
          </div>
        </div>
      </ReactModal>
    </div>
  );
}